<template>
  <div>
    <div
      v-if="currentAccount"
      class="is-flex is-nowrap">
      <div
        style="width: 25%; flex-direction: column; justify-content: center; align-items: center; gap: 20px"
        class="is-flex is-border">
        <div
          style="color: #919191"
          class="is-uppercase is-size-6 has-text-weight-medium">
          Déconnexion automatique
        </div>
        <div class="is-flex is-nowrap">
          <input
            id="delogAutoParams"
            name="delogParams"
            type="checkbox"
            class="switch is-success is-rounded is-large"
            v-model="localDelogActivated">
          <label
            style="color: #5c5c5c"
            class="is-padding-top-xxsmall"
            for="delogAutoParams">
            <span
              style="display: block; width: 100px !important"
              class="is-size-4 has-text-weight is-padding-left-xsmall">{{ !accountRef.delog_activated ? 'ACTIVER' : 'DÉSACTIVER' }}</span>
          </label>
        </div>
      </div>
      <div
        style="width: 75%; background-color: #f9e2d7"
        class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-border">
        <div
          style="word-wrap: break-word; white-space: normal; overflow: hidden; text-overflow: ellipsis; line-height: 2rem"
          class="is-flex is-wrap is-padding-large has-text-weight-bol is-size-6 has-text-weight-bold">
          La déconnexion automatique est une fonctionnalité de sécurité qui vous déconnecte automatiquement de votre compte après une période d’inactivité. Cela protège vos informations personnelles en empêchant l’accès non autorisé à votre compte si vous laissez votre appareil sans surveillance. Par exemple, si vous restez inactif pendant 15 minutes, vous serez déconnecté et devrez vous reconnecter pour continuer à utiliser le service.
        </div>
      </div>
    </div>
    <!-- Data times  -->
    <transition
      v-if="accountRef"
      name="slide-fade">
      <div
        v-if="accountRef.delog_activated"
        style="max-height: 130px"
        class="is-padding">
        <span
          style="color: #919191"
          class="has-text-weight-medium is-size-6">Temps avant déconnexion automatique <i class="has-text-weight-light">(en minutes)</i></span>
        <div class="column is-3 is-padding-left-xxsmall is-margin-top-xsmall">
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square"><span class="icon"><i class="fas fa-stopwatch"></i></span></a>
            </div>
            <p class="control is-expanded">
              <input
                :disabled="!accountRef.delog_activated"
                style="-webkit-appearance: none; -moz-appearance: textfield"
                v-model="accountRef.time_to_delog"
                class="is-border input"
                type="number"
                name="time_to_delog">
            </p>
            <div
              @click="!accountRef.delog_activated ? '' : deleteTimeToDelog()"
              :style="!accountRef.delog_activated ? 'cursor: not-allowed' : 'cursor: pointer'"
              class="control">
              <a
                class="delete-time-delog button is-static is-border is-square"><span class="icon"><i class="fal fa-times additional-hover"></i></span></a>
            </div>
            <div
              @click="!accountRef.delog_activated ? '' : saveTimeToDelog(accountRef)"
              :style="!accountRef.delog_activated ? 'cursor: not-allowed' : 'cursor: pointer'"
              class="control">
              <a
                style="background-color: #82ba74; color: white"
                class="button is-static is-border is-square"><span class="icon"><i class="fas fa-save"></i></span></a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ProfilParamsSecurity',
  mixins: [],
  data () {
    return {
      accountRef: {}
    }
  },
  computed: {
    ...mapState(['currentAccount', 'currentUser']),
    ...mapGetters(['']),

    localDelogActivated: {
      get () {
        return this.currentAccount.delog_activated
      },
      async set (value) {
        try {
          await this.$api.patch(this.$resources.ACCOUNT, this.currentUser.account.pk, { delog_activated: value })
          this.currentAccount.delog_activated = value
          if (value) {
            this.$toasted.global.success('Delog auto activé pour les prochaines sessions ouvertes')
          } else {
            this.$toasted.global.success('Delog auto désactiver pour les prochaines sessions ouvertes')
          }
          this.getAccountRef()
        } catch (err) {
          this.$toasted.global.danger('Erreur lors de la mise à jour. Contactez le support')
        }
      }
    }
  },
  created () {
    this.getAccountRef()
  },
  methods: {
    async getAccountRef () {
      try {
        const request = await this.$api.getOne(this.$resources.ACCOUNT, this.currentUser.account.pk)
        this.accountRef = request.data
      } catch (err) {
        console.log(err)
      }
    },
    async saveTimeToDelog (user) {
      if (user.time_to_delog < 2) {
        this.$toasted.global.danger('Pour des raisons de performances, le temps miminum avant déconnexion automatique est de minimum 2 minutes')
      } else if (user.time_to_delog % 1 !== 0) {
        this.$toasted.global.danger('Veuillez renseigner un nombre entier supérieure à 2.')
      } else {
        try {
          await this.$api.patch(this.$resources.ACCOUNT, user.pk, { time_to_delog: user.time_to_delog })
          this.$toasted.global.success('Le temps de déconnexion automatique a été mis à jour pour les prochaines sessions ouvertes')
        } catch (err) {
          this.$toasted.global.danger('Erreur lors de la mise à jour du temps de déconnexion automatique.')
        }
      }
    }
  }
}
</script>

<style>
.input[type='number']::-webkit-outer-spin-button,
.input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.delete-time-delog {
  pointer-events: auto !important;
  background-color: white !important
}

.delete-time-delog:hover,
.delete-time-delog:hover ~ .additional-hover {
  background-color: red !important;
  color: white
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: opacity 0.5s ease-in-out, max-height 0.5s ease-in-out;
}
.slide-fade-enter, .slide-fade-leave-to{
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}

.slide-fade-enter-to, .slide-fade-leave {
  opacity: 1;
  max-height: 1000px
}
</style>
